// API service for backend communication
// Use local development URL if available
const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost/lysh-scripts/api'
  : 'https://mssqldbateam.com/api';

class ApiService {
  async request(endpoint, options = {}) {
    // Add timestamp to prevent caching
    const separator = endpoint.includes('?') ? '&' : '?';
    const url = `${API_BASE_URL}${endpoint}${separator}_t=${Date.now()}`;
    const config = {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'API request failed');
      }
      
      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Articles
  async getArticles() {
    return this.request('/articles.php');
  }

  async getArticle(id) {
    return this.request(`/articles.php?id=${id}`);
  }

  async createArticle(article) {
    return this.request('/articles.php', {
      method: 'POST',
      body: JSON.stringify(article),
    });
  }

  async updateArticle(id, article) {
    return this.request(`/articles.php?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(article),
    });
  }

  async deleteArticle(id) {
    return this.request(`/articles.php?id=${id}`, {
      method: 'DELETE',
    });
  }

  // Scripts
  async getScripts() {
    return this.request('/scripts.php');
  }

  async getScript(id) {
    return this.request(`/scripts.php?id=${id}`);
  }

  async createScript(script) {
    return this.request('/scripts.php', {
      method: 'POST',
      body: JSON.stringify(script),
    });
  }

  async updateScript(id, script) {
    return this.request(`/scripts.php?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(script),
    });
  }

  async deleteScript(id) {
    return this.request(`/scripts.php?id=${id}`, {
      method: 'DELETE',
    });
  }

  async trackDownload(id) {
    return this.request(`/scripts.php?download=1&id=${id}`);
  }

  // Authentication
  async login(credentials) {
    return this.request('/auth.php?action=login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }

  async register(userData) {
    return this.request('/auth.php?action=register', {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }

  async logout() {
    return this.request('/auth.php?action=logout', {
      method: 'POST',
    });
  }

  async verifyToken() {
    return this.request('/auth.php?action=verify');
  }

  async changePassword(passwordData) {
    return this.request('/auth.php?action=change_password', {
      method: 'POST',
      body: JSON.stringify(passwordData),
    });
  }

  // FAQs
  async getFaqs() {
    return this.request('/faqs.php');
  }

  async getFaq(id) {
    return this.request(`/faqs.php?id=${id}`);
  }

  async createFaq(faq) {
    return this.request('/faqs.php', {
      method: 'POST',
      body: JSON.stringify(faq),
    });
  }

  async updateFaq(id, faq) {
    return this.request(`/faqs.php?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(faq),
    });
  }

  async deleteFaq(id) {
    return this.request(`/faqs.php?id=${id}`, {
      method: 'DELETE',
    });
  }

  // Tools
  async getTools() {
    return this.request('/tools.php');
  }

  async getTool(id) {
    return this.request(`/tools.php?id=${id}`);
  }

  async createTool(tool) {
    return this.request('/tools.php', {
      method: 'POST',
      body: JSON.stringify(tool),
    });
  }

  async updateTool(id, tool) {
    return this.request(`/tools.php?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(tool),
    });
  }

  async deleteTool(id) {
    return this.request(`/tools.php?id=${id}`, {
      method: 'DELETE',
    });
  }

  async uploadToolFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const separator = '/tools.php?upload=1'.includes('?') ? '&' : '?';
    const url = `${API_BASE_URL}/tools.php?upload=1${separator}_t=${Date.now()}`;
    
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData,
    });
    
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'File upload failed');
    }
    return data;
  }

  async trackToolDownload(id) {
    return this.request(`/tools.php?download=1&id=${id}`);
  }

  // Analytics
  async trackPageView(pageId) {
    return this.request('/analytics.php', {
      method: 'POST',
      body: JSON.stringify({
        event_type: 'page_view',
        content_id: pageId,
      }),
    });
  }
}

export default new ApiService();